<template lang="">
    <div class="modal width2" v-if="isPayment">
        <a  class="modal_close" @click="$emit('close')"></a>
        <div class="modal_header">
            <div class="title">구매내역</div>
        </div>
        <div class="modal_body">
            <ul class="modal_list">
                <li>구매내역은 소득공제용 영수증 및 매입 세금계산서로 활용할 수 없으며, 결제가 완료되었음을 증명하는 용도로만 활용 가능합니다.</li>
                <li>구매내역은 세무상의 지출증빙 효력이 없습니다.</li>
            </ul>
            <div class="modal_tbl">
                <table>
                    <tbody>
                        <tr>
                            <th>기부자</th>
                            <td>{{ payment.name }}</td>
                        </tr>
                        <tr>
                            <th>일시</th>
                            <td>{{ payment.paidAt }}</td>
                        </tr>
                        <tr>
                            <th>주문번호</th>
                            <td>{{ payment.paymentId }} ({{ payment.orderNum }})</td>
                        </tr>
                        <tr>
                            <th>상품명</th>
                            <td class="product_name">{{ payment.campaignName }}</td>
                        </tr>
                        <tr>
                            <th>결제금액</th>
                            <td class="amount">{{ $addComma(payment.amount) }}원</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="common_btn">
                <button type="button" class="btn_close" @click="$emit('close')">닫기</button>
                <button type="button" class="btn_print">인쇄하기</button>
            </div>
        </div>
    </div>
    <div class="modal" v-else>
        <a class="modal_close" @click="$emit('close')"></a>
        <div class="modal_header">
            <div class="title">구매내역</div>
        </div>
        <div class="modal_body">
            <div class="member">
                <div class="form_wrap">
                    <p class="title">이름</p>
                    <input type="text" placeholder="이름을 입력해주세요." v-model="name">
                </div>
                <div class="form_wrap">
                    <p class="title">연락처</p>
                    <input type="text" placeholder="연락처를 입력해주세요." v-model="phoneNum">
                </div>
                <div class="form_wrap">
                    <p class="title">구매번호</p>
                    <input type="text" placeholder="구매번호를 입력해주세요." v-model="paymentId">
                </div>
                <button type="button" class="btn_login" @click="getPayment">조회</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

const paymentModule = 'paymentModule'

export default {
    data () {
        return {
            isPayment: false,
            paymentId: '',
            name: '',
            phoneNum: ''
        }
    },

    methods: {
        ...mapActions(paymentModule, ['requestPaymentReceipt']),

        async getPayment() {
            if (this.paymentId === '') {
                alert('주문번호를 입력해 주세요.')
                return
            }
            if (this.name === '') {
                alert('이름을 입력해 주세요.')
                return
            }
            if (this.phoneNum === '') {
                alert('연락처를 입력해 주세요.')
                return
            }
            const {paymentId, name, phoneNum} = this
            const result = await this.requestPaymentReceipt({paymentId, name, phoneNum})
            if (result === '성공') {
                this.isPayment = true
            } else {
                this.$emit('close')
                this.$parent?.$openModal('alertModal', {
                    message: result,
                });
            }
        }
    },

    computed: {
        ...mapState(paymentModule, ['payment'])
    },
}
</script>
<style lang="">

</style>